import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { CreateDisbursementPage } from './pages/CreateDisbursement/CreateDisbursementPage';
import { CreateDisbursementSuccessPage } from './pages/CreateDisbursementSuccessPage';
import { DisbursementViewPage } from './pages/DisbursementViewPage';
import { ViewDisbursementsPage } from './pages/ViewDisbursements/ViewDisbursementsPage';

export const DisbursementRouting = () => {
  return (
    <Routes>
      <Route
        path="/view"
        element={
          <RouteAuth access={[Role.DisbursementView, Role.DisbursementManage]}>
            <ViewDisbursementsPage />
          </RouteAuth>
        }
      />
      <Route
        path="/view/:id"
        element={
          <RouteAuth access={[Role.DisbursementView, Role.DisbursementManage]}>
            <DisbursementViewPage />
          </RouteAuth>
        }
      />
      <Route
        path="/manage"
        element={
          <RouteAuth access={[Role.DisbursementManage]}>
            <CreateDisbursementPage />
          </RouteAuth>
        }
      />
      <Route
        path="/manage/:id/success"
        element={
          <RouteAuth access={[Role.DisbursementManage]}>
            <CreateDisbursementSuccessPage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
